import styles from "./TaggedImage.module.css";
import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokRouter } from "@/data/routes/bloks.route";
import type { BlokTaggedProductCard } from "@/storyblok";
import type { BlokProps } from "@frend-digital/storyblok";
import { AssetBlok, sizes } from "../Asset";
import { MediaLink } from "../MediaLink";
import { FloatingProduct } from "@/components/ui/FloatingProduct/FloatingProduct";
import { clsx } from "@frend-digital/ui";

export const TaggedImageBlok = ({
	blok,
	data,
	className,
}: BlokProps<BlokTaggedProductCard, BlokRouter["taggedImage"]> & { className?: string }) => {
	if (!blok.image) return null;

	return (
		<BlokWrap editable={blok} asChild>
			<div className={clsx(styles.root, className)}>
				<div className={clsx(styles.floatingProducts, styles.desktop)}>
					{data?.desktop?.map((product) => (
						<FloatingProduct
							key={product.product.displayItemId}
							product={product}
							color={blok.tagColor}
						/>
					))}
				</div>
				<div className={clsx(styles.floatingProducts, styles.mobile)}>
					{data?.mobile?.map((product) => (
						<FloatingProduct
							key={product.product.displayItemId}
							product={product}
							color={blok.tagColor}
						/>
					))}
				</div>
				<div className={styles.imageContainer}>
					<MediaLink link={blok.mediaLink} contentType={blok.component} itemId={blok._uid}>
						<AssetBlok source={blok.image} quality={90} sizes={sizes(100, 80)} />
					</MediaLink>
				</div>
			</div>
		</BlokWrap>
	);
};
